import * as React from 'react';
import cx from 'classnames';
import { useStaticQuery, graphql } from 'gatsby';

import { Link } from '../Link/Link';
import { routes } from '../../config/routes';

import * as cs from './Legal.module.css';

interface Props {
  mobileOnly?: boolean;
}

export const Legal = ({ mobileOnly }: Props) => {
  const { snippet } = useStaticQuery(graphql`
    query {
      snippet(slug: { eq: "legal" }) {
        id
        data
      }
    }
  `);

  const { privacy, cookies, notice } = snippet.data;

  const handleIubendaSettingsClick = (event: any) => {
    // Click already handled by iubenda
    if (event.target.getAttribute('data-iub-enabled')) {
      event.stopPropagation();
      event.preventDefault();
      return;
    }

    if (
      typeof window !== 'undefined' &&
      // @ts-expect-error TS(2339): Property '_iub' does not exist on type 'Window & t... Remove this comment to see the full error message
      window._iub &&
      // @ts-expect-error TS(2339): Property '_iub' does not exist on type 'Window & t... Remove this comment to see the full error message
      window._iub.cs &&
      // @ts-expect-error TS(2339): Property '_iub' does not exist on type 'Window & t... Remove this comment to see the full error message
      window._iub.cs.ui
    ) {
      event.stopPropagation();
      event.preventDefault();
      // We open modal manually as iubenda can't update
      // iubenda-cs-preferences-link after route change
      // @ts-expect-error TS(2339): Property '_iub' does not exist on type 'Window & t... Remove this comment to see the full error message
      window._iub.cs.ui.openPreferences(event.target, event);
    }
  };

  return (
    <>
      <div className={cx(cs.legal, { [cs.mobileOnly]: mobileOnly })}>
        <Link className={cs.legalLink} to={routes.privacy}>
          {privacy}
        </Link>
      </div>

      <div className={cx(cs.legal, { [cs.mobileOnly]: mobileOnly })}>
        <Link
          to={routes.cookies}
          className={cx(cs.legalLink, 'iubenda-cs-preferences-link')}
          onClick={handleIubendaSettingsClick}
        >
          {cookies}
        </Link>
      </div>

      <div className={cx(cs.legal, { [cs.mobileOnly]: mobileOnly })}>
        <Link
          to={routes.noticeAtCollection}
          className={cx(cs.legalLink, 'iubenda-cs-uspr-link')}
        >
          {notice}
        </Link>
      </div>
    </>
  );
};
